export enum eApiTags {
  TransactionInformation = 'Transaction-Information',
}
